function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Reports_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "Reports_svg__a",
  transform: "translate(22 177)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Reports_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Reports_svg__c",
  d: "M.5 12.48A11.575 11.575 0 0112.02.96v11.52l8.455 7.824a11.527 11.527 0 01-8.455 3.7A11.575 11.575 0 01.5 12.48zm1.44 0a10.091 10.091 0 0010.08 10.08 10.114 10.114 0 006.344-2.247l-7.322-6.775-.462-1.058V2.5a10.094 10.094 0 00-8.64 9.98zm11.04-.96l9.6-3.84a11.309 11.309 0 01.96 4.8 11.524 11.524 0 01-2.2 6.769zm2.652.491l5.4 4.991A10.021 10.021 0 0022.1 12.48a10.96 10.96 0 00-.359-2.913zM13.94 0a11.646 11.646 0 018.64 5.76L13.94 9.6zm1.44 7.385l5.023-2.233a10.038 10.038 0 00-5.023-3.376z"
}));

function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgReports;